<nav class="column" [class.show]="opened()">
  <div class="content-wrapper" tabindex="-1" id="sidenav" aria-labelledby="sidenavLabel" role="dialog">

    <h5 id="sidenavLabel">{{"CATEGORY"|translate}}</h5>

    <ul class="nav nav-pills">

      @for (rule of rulesService.rules; track rule.id; let i = $index) {

      @if(rulesService.isHighEndWatchesRule(rule)){
      <li class="nav-item" [id]="'flush-heading-'+rule.id">

        <button class="btn btn-link collapsed" [class.active]="isActiveParent(rule.id)" type="button"
          data-bs-toggle="collapse" [attr.data-bs-target]="'#flush-'+rule.id" aria-expanded="false"
          [attr.aria-controls]="'flush-'+rule.id">
          {{rule.name}}
        </button>

      </li>

      <div [id]="'flush-'+rule.id" class="accordion-collapse collapse" [attr.aria-labelledby]="'flush-heading-'+rule.id"
        data-bs-parent="#sidenav">

        <ul class="nav nav-pills">

          @for(subCategory of rule.subCategories; track subCategory.id){
          <li class="nav-item">
            <button class="btn btn-link" [class.active]="isActive(subCategory.id)"
              (click)="handleRuleClick(subCategory)">
              {{subCategory.name}}
            </button>
          </li>
          }

        </ul>

      </div>

      }@else{

      <li class="nav-item">
        <button class="btn btn-link" [class.active]="isActive(rule.id)" (click)="handleRuleClick(rule)">
          {{rule.name}}
        </button>
      </li>
      }

      }

      @if(tecService.isTermsAndConditionConfirmed() && (authService.user?.isUserStore)){

      <hr>

      <li class="nav-item my-bulgari">
        <a class="dropdown-item" routerLink="/main/my-bulgari" routerLinkActive="active" [routerLinkActiveOptions]="{exact:
true}">
          {{"My Bulgari"|translate}}</a>
      </li>
      }

    </ul>

    @if(tecService.isTermsAndConditionConfirmed()){
    <ul class="nav nav-pills account">
      <hr>

      <li class="nav-item">
        <a class="dropdown-item" (click)="authService.logout()" style="cursor: pointer;"
          routerLinkActive="active">{{"Logout"|translate}}</a>
      </li>

      <li class="nav-item">
        <span class="dropdown-item version"> v. {{version}} </span>
      </li>
    </ul>
    }

  </div>

  <div class="anchor">

    <div class="column first" [class.show]="showFirstColumn()  && sidenavColumns()[0]">

      <app-sidenav-section [section]="sidenavColumns()[0]"></app-sidenav-section>

      <div class="anchor">

        <div class="column second" [class.show]="showSecondColumn() && sidenavColumns()[1] ">

          <app-sidenav-section [section]="sidenavColumns()[1]"></app-sidenav-section>

          <div class="anchor">

            <div class="column third" [class.show]="showThirdColumn() && sidenavColumns()[2]">

              <app-sidenav-section [section]="sidenavColumns()[2]"></app-sidenav-section>

            </div>

            @if (newIn()) {
            <div class="column third" [class.show]="showThirdColumn()">

              <div class="content-wrapper new-in-wrapper">
                <app-new-in [newIn]="newIn()"></app-new-in>
              </div>

            </div>
            }

          </div>

        </div>

      </div>

    </div>

  </div>

</nav>

<div class="overlay" [class.show]="sidenavService.opened()" (click)="sidenavService.close()"></div>
